import { reactions } from "@/mocks/home";

export default function CrowdReaction() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="shell grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <span className="text-xs font-semibold tracking-[0.2em] text-primary-600">
              VOICE FROM THE CROWD · 现场声音
            </span>
            <h2 className="mt-2 font-serif text-2xl font-bold text-foreground-950 md:text-3xl">
              人群在说什么，比现场更抓人
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600">
              看热闹的不只是眼睛，还有一张张藏不住的表情和一句句真实吐槽。跟着围观群众的
              视角，感受同一种好奇、意外与恍然大悟。
            </p>

            <div className="mt-8 hidden items-start gap-3 rounded-lg border border-accent-200 bg-accent-50 p-4 lg:flex">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-quote-text"></i>
              </span>
              <p className="text-sm leading-relaxed text-accent-900">
                “围观从来不只有一种情绪——
                有人赶来凑热闹，也有人站着站着就看懂了整件事。”
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-5 lg:col-span-8">
          {reactions.map((r, idx) => (
            <article
              key={idx}
              className="grid grid-cols-1 gap-4 rounded-lg border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-primary-200 sm:grid-cols-12 sm:gap-5 sm:p-5"
            >
              <div
                className={
                  "relative h-44 w-full overflow-hidden rounded-md sm:h-auto " +
                  (idx % 2 === 0 ? "sm:col-span-4" : "sm:order-last sm:col-span-4")
                }
              >
                <img
                  src={r.image}
                  alt={r.mood}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div
                className={
                  "flex flex-col justify-center gap-3 " +
                  (idx % 2 === 0 ? "sm:col-span-8" : "sm:col-span-8")
                }
              >
                <div className="flex flex-wrap items-center gap-2">
                  <span className="flex items-center gap-1 whitespace-nowrap text-[11px] text-secondary-700">
                    <i className="ri-map-pin-line"></i>
                    {r.scene}
                  </span>
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] text-accent-800">
                    {r.mood}
                  </span>
                </div>
                <p className="font-serif text-base font-semibold leading-relaxed text-foreground-950 md:text-lg">
                  “{r.quote}”
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-200 text-secondary-800">
                    <i className="ri-user-smile-line"></i>
                  </span>
                  {r.people}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}